/**
 * "Is there a newer version of this page?" (2026-09-29). Anthony: "give a
 * pop-up or a banner that clearly says, 'New version of the page available.
 * Please click refresh.'"
 *
 * The portal is a single-page app: its code loads ONCE per page load, so a
 * deploy reaches nobody who is already on a page, however much they click
 * around. The build names its bundle by content hash (main.<hash>.js), so
 * "which version am I running" is the <script> this page loaded, and "which
 * version is live" is the one the site's index.html names right now. No build
 * step, no version file: the two file names ARE the versions. Pure.
 */
const MAIN_RE = /\/static\/js\/main\.([a-z0-9]+)\.js/;

/** The bundle hash an HTML string (the live index.html) points at, or null. */
export const bundleHashIn = (html) => {
	const m = MAIN_RE.exec(String(html || ''));
	return m ? m[1] : null;
};

/** The bundle hash THIS page is running, or null (dev server: bundle.js). */
export const runningBundleHash = (doc = typeof document !== 'undefined' ? document : null) => {
	if (!doc) return null;
	const scripts = Array.from(doc.querySelectorAll('script[src]'));
	for (const s of scripts) {
		const m = MAIN_RE.exec(s.getAttribute('src') || '');
		if (m) return m[1];
	}
	return null;
};

/** A newer version is live when both are known and they differ. */
export const isNewer = (running, live) => Boolean(running && live && running !== live);

/**
 * Where "Refresh" goes: the same page with a one-off `_v` query, so no
 * cache anywhere (browser or CDN) can hand back the old page; the banner
 * strips it again on load (cleanUrl).
 */
export const refreshUrl = (loc, live) => {
	const params = new URLSearchParams(loc.search || '');
	params.set('_v', live || String(Date.now()));
	return `${loc.pathname}?${params.toString()}${loc.hash || ''}`;
};

/** The current URL without the refresh marker, or null if there is none. */
export const cleanUrl = (loc) => {
	const params = new URLSearchParams(loc.search || '');
	if (!params.has('_v')) return null;
	params.delete('_v');
	const q = params.toString();
	return `${loc.pathname}${q ? `?${q}` : ''}${loc.hash || ''}`;
};
